import React, { useState, useEffect } from 'react';
import FilterBar from '../../components/Post/FilterBar.tsx';
import DetailedPane from '../../components/Comments/DetailedPane.tsx';
import DeleteConfirmation from '../../components/Comments/DeleteConfirmation.tsx';
import useComments from '../../hooks/useComments.tsx';
import PaginationControls from '../../utils/pagination';
import CommentsTable from '../../components/Comments/CommentsTable.tsx';
import BaseComments from './BaseComments.tsx';

const AllComments = () => {
  const commentsHook = useComments();

  return <BaseComments title="" />;
};

export default AllComments;
